import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountActivationRoutingModule } from './account-activation-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FooterModule } from '../../../shared/footer/footer.module';
import { HeaderModule } from '../../../shared/header/header.module';
import { ValidationErrorsModule } from '../../../shared/validation-errors/validation-errors.module';
import { AccountActivationComponent } from './account-activation.component';
import { NgZorroIconModule } from '../../../modules/nz-icon-antd.module';
import { NgZorroAntdModule } from '../../../modules/nz-zorro-antd.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [
		AccountActivationComponent
	],
	imports: [
		CommonModule,
		NgZorroAntdModule,
		NgZorroIconModule,
		AccountActivationRoutingModule,
		ReactiveFormsModule,
		HeaderModule,
		FooterModule,
		ValidationErrorsModule,
		TranslateModule
	]
})

export class AccountActivationModule { }
